require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/fn/set-immediate.js
// module id = 1559
// module chunks = 1